import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../Synonyms.module.scss';

const DirectionIcon = ({ variant }) => {
  if (variant === 'exchange') {
    return (
      <svg
        className={styles.directionIcon}
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
      >
        <path d="M5 8h13" />
        <path d="m15 5 3 3-3 3" />
        <path d="M19 16H6" />
        <path d="m9 13-3 3 3 3" />
      </svg>
    );
  }

  return (
    <svg
      className={styles.directionIcon}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <path d="M5 12h14" />
      <path d="m15 8 4 4-4 4" />
    </svg>
  );
};

DirectionIcon.propTypes = {
  variant: PropTypes.oneOf(['exchange', 'forward']).isRequired,
};

export default DirectionIcon;
